import React from 'react';
import { useLocation } from 'react-router';

import { analytics } from '@/analytics';

import { Auth } from '@/containers/useAuth';

export const AnalyticsTracker: React.FC = () => {
  const { context } = Auth.useContainer();
  const { pathname, search } = useLocation();

  // Track user
  React.useEffect(() => {
    if (!context?.user) return analytics.setCurrentUser();

    const {
      id,
      details: { email, firstName, lastName }
    } = context.user;

    return analytics.setCurrentUser({ id, email, firstName, lastName });
  }, [context?.user]);

  // Track page views upon navigation
  React.useEffect(() => {
    analytics.trackPage(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};
